export default {
	/**
	 * Set all fields
	 * @param {Array} standardizationFields 
	 */
	setAllStandardizationFields(state, standardizationFields) {
		state.all = standardizationFields
	},
}
